exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-border {\n    border-radius: 50%;\n    border-width: 2px;\n    border-style: solid;\n}\n\n.avatar-available {\n    border-color: #00ec07;\n}\n\n.avatar-unavailable {\n    border-color: #e10000;\n}\n\n.personal-info-container {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    width: 100%;\n}\n\n.personal-info-header {\n    grid-column: span 2;\n    font-size: 1.2em;\n    margin: 5px 10px;\n}\n\n.user-grid {\n    margin-top: 5px;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n}\n\n.user-avatar {\n    grid-row: span 4;\n}\n\n.grid-controls {\n    grid-column: span 1;\n}", ""]);

// exports
